let skus = {};
let codes = [];
let currentMeta = { total_skus: 0 };

function renderHeaderStats(){
  document.getElementById('hdrTotal').textContent = currentMeta.total_skus ?? codes.length;
  document.getElementById('hdrA').textContent = codes.filter(c=>skus[c].lineas.A.produce).length;
  document.getElementById('hdrB').textContent = codes.filter(c=>skus[c].lineas.B.produce).length;
  document.getElementById('hdrC').textContent = codes.filter(c=>skus[c].lineas.C.produce).length;
}

function pillLinea(prod, exc){
  if(!prod) return '<span class="pill no">NO</span>';
  if(exc) return '<span class="pill exc">SÍ · AUTO</span>';
  return '<span class="pill si">SÍ</span>';
}

function fmt(v, dec){
  if(v===null || v===undefined || v==='') return '—';
  if(typeof v === 'number'){
    return dec!==undefined ? v.toFixed(dec) : v.toString();
  }
  return v;
}

// Convierte un valor expresado "por minuto" a "por hora" (x60). Los datos
// fuente (plantillas de referencia) traen las velocidades por minuto; la
// pantalla las muestra por hora, que es la unidad que se usa para planear.
function porHora(v){
  return (v===null || v===undefined) ? null : v*60;
}

const NOMBRE_EQUIPO = { A:'LAW42-2', B:'LAW52-1', C:'LAW52-2' };

function renderResultadosLinea(letra, query){
  const box = document.getElementById('listaResultados'+letra);
  const q = (query||'').trim().toUpperCase();
  let matches = codes.filter(c => skus[c].lineas[letra].produce);
  if(q){
    matches = matches.filter(c=>{
      const e = skus[c];
      return c.toUpperCase().includes(q) || (e.descripcion||'').toUpperCase().includes(q);
    });
  }
  matches = matches.slice(0,60);
  if(matches.length===0){ box.innerHTML = '<div class="empty-state">Sin resultados.</div>'; return; }
  box.innerHTML = matches.map(c=>{
    const e = skus[c];
    const info = e.lineas[letra];
    const badge = info.excepcion_config ? (info.identificacion.tipo_empaque.startsWith('Mixto') ? info.identificacion.tipo_empaque : 'AUTOMÁTICO') : 'ESTÁNDAR';
    return `<div class="resultado-item" data-codigo="${c}">
      <div class="resultado-info"><b>${c}</b> — <span class="resultado-desc">${e.descripcion}</span></div>
      <div class="resultado-lineas"><span class="pill ${info.excepcion_config?'exc':'si'}">${badge}</span></div>
    </div>`;
  }).join('');
  box.querySelectorAll('.resultado-item').forEach(el=>{
    el.addEventListener('click', ()=> mostrarReferenciaEnLinea(letra, el.dataset.codigo));
  });
}

function badgeEmpaque(info){
  const tipo = info.identificacion.tipo_empaque || '';
  if(tipo.startsWith('Mixto')) return `<span class="pill exc">MIXTO · ${tipo.replace('Mixto ','')}</span>`;
  if(info.excepcion_config) return '<span class="pill exc">EXCEPCIÓN · EMPAQUE AUTOMÁTICO</span>';
  return '<span class="pill si">CONFIGURACIÓN ESTÁNDAR</span>';
}


const DIVISIONES_MIXTO = {
  "Manual":      { pctAuto: 0,    categoria: "Ambas"  },
  "Automatico":  { pctAuto: 1,    categoria: "Ambas"  },
  "Mixto 50/50": { pctAuto: 0.5,  categoria: "Ambas"  },
  "Mixto 67/33": { pctAuto: 2/3,  categoria: "Chico"  },
  "Mixto 75/25": { pctAuto: 0.75, categoria: "Grande" },
};

function calcularCascadaMixto(tipoEmpaque, mesasEmpaque, mesasSellado, procesoReal, maxAuto, totalPaqCiclo, paqCaja){
  const def = DIVISIONES_MIXTO[tipoEmpaque];
  const pctAuto = def ? def.pctAuto : 0;
  const pctManual = 1 - pctAuto;
  const paqCicloAuto = Math.round(pctAuto * totalPaqCiclo);
  const paqCicloManual = totalPaqCiclo - paqCicloAuto;
  const asignadoAuto = pctAuto * procesoReal;
  const asignadoManual = pctManual * procesoReal;
  const maxManual = (mesasEmpaque && mesasSellado) ? Math.min(mesasEmpaque*40, mesasSellado*29) : null;
  const cuelloAuto = Math.min(asignadoAuto, maxAuto);
  const cuelloManual = maxManual===null ? asignadoManual : Math.min(asignadoManual, maxManual);
  const real = cuelloAuto + cuelloManual;
  const cajasMin = paqCaja ? real/paqCaja : null;
  const ganancia = maxAuto ? (real/maxAuto - 1) : null;
  return { pctAuto, pctManual, paqCicloAuto, paqCicloManual, asignadoAuto, asignadoManual,
           maxManual, cuelloAuto, cuelloManual, real, cajasMin, ganancia };
}

function filaComparativa(etiqueta, r, destacar){
  const b = destacar ? 'style="font-weight:700;"' : '';
  return `<tr ${b}><td>${etiqueta}</td>
    <td>${(r.pctAuto*100).toFixed(1)}% / ${(r.pctManual*100).toFixed(1)}%</td>
    <td>${porHora(r.cuelloAuto).toFixed(1)}</td>
    <td>${porHora(r.cuelloManual).toFixed(1)}</td>
    <td>${porHora(r.real).toFixed(1)}</td>
    <td>${r.cajasMin===null?'—':porHora(r.cajasMin).toFixed(1)}</td>
    <td>${r.ganancia===null?'—':(r.ganancia*100).toFixed(1)+'%'}</td>
  </tr>`;
}

function recalcularMixtoUI(codigo){
  const info = skus[codigo].lineas.C;
  const id = info.identificacion, ve = info.velocidad, mx = info.empaque_mixto;
  const tipoSel = document.getElementById('mixtoDivisionSel').value;
  const mesasE = parseInt(document.getElementById('mixtoMesasE').value) || null;
  const mesasS = parseInt(document.getElementById('mixtoMesasS').value) || null;

  const def = DIVISIONES_MIXTO[tipoSel];
  const catOk = !def || def.categoria === 'Ambas' || def.categoria === mx.categoria_diametro;

  const base = calcularCascadaMixto('Automatico', null, null, ve.paq_min_real_proceso, ve.max_paq_min_empacadora, mx.total_paq_ciclo, id.paq_caja);
  const elegido = calcularCascadaMixto(tipoSel, mesasE, mesasS, ve.paq_min_real_proceso, ve.max_paq_min_empacadora, mx.total_paq_ciclo, id.paq_caja);

  const warn = catOk ? '' : `<div class="ref-badges" style="margin:8px 0;"><span class="pill no">REVISAR — "${tipoSel}" no es una división válida para categoría ${mx.categoria_diametro}</span></div>`;

  const tabla = `
    <table style="margin-top:10px;">
      <thead>
        <tr><th>Escenario</th><th>% Auto/Manual</th><th>Paq/Hora Auto</th><th>Paq/Hora Manual</th><th>Paq/Hora Real</th><th>Cajas/Hora Real</th><th>Ganancia vs 100% Auto</th></tr>
      </thead>
      <tbody>
        ${filaComparativa('100% Automático (referencia)', base, false)}
        ${filaComparativa('Elegido: ' + tipoSel + (mesasE&&mesasS?` (${mesasE} mesa emp. + ${mesasS} mesa sell.)`:''), elegido, true)}
      </tbody>
    </table>`;

  document.getElementById('mixtoResultado').innerHTML = warn + tabla;
}

function bloqueEmpaqueMixto(mx, codigo){
  if(!mx) return '';
  const cobPill = mx.cobertura_manual_validada === 'OK' ? 'si' : (mx.cobertura_manual_validada.startsWith('N/A') ? 'si' : 'no');
  const valPill = mx.validacion_division === 'OK' ? 'si' : (mx.validacion_division === '' ? 'si' : 'no');

  const idActual = (skus[codigo] && skus[codigo].lineas.C.identificacion.tipo_empaque) || 'Manual';
  const opcionesDivisionSel = Object.keys(DIVISIONES_MIXTO).filter(k => {
    const cat = DIVISIONES_MIXTO[k].categoria;
    return cat === 'Ambas' || cat === mx.categoria_diametro;
  }).map(k => `<option value="${k}" ${k===idActual?'selected':''}>${k}</option>`).join('');

  return `
      <div class="subhead">Empaque Mixto — división Automático/Manual (Línea C)</div>
      <div class="kv-grid">
        <div class="kv"><div class="l">Categoría Diámetro</div><div class="v">${fmt(mx.categoria_diametro)}</div></div>
        <div class="kv"><div class="l">Total Paq/Ciclo</div><div class="v">${fmt(mx.total_paq_ciclo)}</div></div>
        <div class="kv"><div class="l">Paq/Ciclo → Automático</div><div class="v">${fmt(mx.paq_ciclo_automatico)}</div></div>
        <div class="kv"><div class="l">Paq/Ciclo → Manual</div><div class="v">${fmt(mx.paq_ciclo_manual)}</div></div>
        <div class="kv"><div class="l">Mesas Empaque Manual</div><div class="v">${fmt(mx.mesas_empaque_manual)}</div></div>
        <div class="kv"><div class="l">Mesas Sellado Manual</div><div class="v">${fmt(mx.mesas_sellado_manual)}</div></div>
      </div>
      <div class="ref-badges" style="margin:2px 0 14px;">
        <span class="pill ${cobPill}">Cobertura manual: ${fmt(mx.cobertura_manual_validada)}</span>
        <span class="pill ${valPill}">División: ${mx.validacion_division === '' ? 'N/A' : fmt(mx.validacion_division)}</span>
      </div>
      <table>
        <tbody>
          <tr><td>Paq/Hora Asignado Automático</td><td>${fmt(porHora(mx.paq_min_asignado_automatico),1)}</td><td>Paq/Hora Asignado Manual</td><td>${fmt(porHora(mx.paq_min_asignado_manual),1)}</td></tr>
          <tr><td>Paq/Hora Cuello Automático</td><td>${fmt(porHora(mx.paq_min_cuello_automatico),1)}</td><td>Paq/Hora Cuello Manual</td><td>${fmt(porHora(mx.paq_min_cuello_manual),1)}</td></tr>
          <tr><td><b>Paq/Hora Real Final (Mixto)</b></td><td><b>${fmt(porHora(mx.paq_min_real_final),1)}</b></td><td><b>Cajas/Hora Real Final</b></td><td><b>${fmt(porHora(mx.cajas_min_real_final),1)}</b></td></tr>
          <tr><td>% Ganancia vs 100% Automático</td><td colspan="3">${mx.pct_ganancia_vs_automatico===null?'—':(mx.pct_ganancia_vs_automatico*100).toFixed(1)+'%'}</td></tr>
        </tbody>
      </table>

      <div class="subhead">Simulador — elegir división y comparar contra 100% Automático</div>
      <div class="filtros" style="margin-bottom:6px;">
        <label style="font-size:11.5px;color:var(--text-dim);">División
          <select id="mixtoDivisionSel" onchange="recalcularMixtoUI('${codigo}')">${opcionesDivisionSel}</select>
        </label>
        <label style="font-size:11.5px;color:var(--text-dim);">Mesas Empaque Manual
          <select id="mixtoMesasE" onchange="recalcularMixtoUI('${codigo}')">
            <option value="" ${!mx.mesas_empaque_manual?'selected':''}>—</option>
            <option value="1" ${mx.mesas_empaque_manual===1?'selected':''}>1</option>
            <option value="2" ${mx.mesas_empaque_manual===2?'selected':''}>2</option>
          </select>
        </label>
        <label style="font-size:11.5px;color:var(--text-dim);">Mesas Sellado Manual
          <select id="mixtoMesasS" onchange="recalcularMixtoUI('${codigo}')">
            <option value="" ${!mx.mesas_sellado_manual?'selected':''}>—</option>
            <option value="1" ${mx.mesas_sellado_manual===1?'selected':''}>1</option>
            <option value="2" ${mx.mesas_sellado_manual===2?'selected':''}>2</option>
            <option value="3" ${mx.mesas_sellado_manual===3?'selected':''}>3</option>
          </select>
        </label>
        <button class="chip active" onclick="recalcularMixtoUI('${codigo}')">Recalcular</button>
      </div>
      <div id="mixtoResultado"></div>`;
}

function calcularManualA(mesasE, mesasS, procesoReal, paqCaja, kgMinRealProceso){
  const maxManual = (mesasE && mesasS) ? Math.min(mesasE*40, mesasS*29) : null;
  const cuelloPaqMin = maxManual===null ? procesoReal : Math.min(procesoReal, maxManual);
  const factor = procesoReal ? (cuelloPaqMin / procesoReal) : 0;
  const cajasMin = paqCaja ? cuelloPaqMin/paqCaja : null;
  const kgMin = kgMinRealProceso * factor;
  const paqHora = cuelloPaqMin*60, cajasHora = cajasMin===null?null:cajasMin*60, kgHora = kgMin*60;
  // La planta opera 144 h/semana (24 h/día); Semana = Hora x144, Día = Hora x24.
  return {
    maxManual,
    paqHora, paqDia: paqHora*24, paqSem: paqHora*144,
    cajasHora, cajasDia: cajasHora===null?null:cajasHora*24, cajasSem: cajasHora===null?null:cajasHora*144,
    kgHora, kgDia: kgHora*24, kgSem: kgHora*144,
  };
}

function filaComparativaA(etiqueta, r, destacar){
  const b = destacar ? 'style="font-weight:700;"' : '';
  const f = (v,d) => v===null||v===undefined ? '—' : v.toFixed(d);
  return `<tr ${b}><td>${etiqueta}</td>
    <td>${f(r.paqHora,1)}</td><td>${f(r.paqDia,0)}</td><td>${f(r.paqSem,0)}</td>
    <td>${f(r.cajasHora,1)}</td><td>${f(r.cajasDia,0)}</td><td>${f(r.cajasSem,0)}</td>
    <td>${f(r.kgHora,1)}</td><td>${f(r.kgDia,1)}</td><td>${f(r.kgSem,1)}</td>
  </tr>`;
}

function recalcularManualAUI(codigo){
  const info = skus[codigo].lineas.A;
  const ve = info.velocidad, id = info.identificacion, cm = info.config_manual;
  const mesasE = parseInt(document.getElementById('manualAMesasE').value) || null;
  const mesasS = parseInt(document.getElementById('manualAMesasS').value) || null;

  const base = calcularManualA(cm.mesas_empaque_manual_std, cm.mesas_sellado_manual_std, ve.paq_min_real_proceso, id.paq_caja, ve.kg_min_real);
  const elegido = calcularManualA(mesasE, mesasS, ve.paq_min_real_proceso, id.paq_caja, ve.kg_min_real);

  const tabla = `
    <table style="margin-top:10px;">
      <thead>
        <tr><th>Escenario</th><th>Paq/Hora</th><th>Paq/Día</th><th>Paq/Sem</th><th>Cajas/Hora</th><th>Cajas/Día</th><th>Cajas/Sem</th><th>Kg/Hora</th><th>Kg/Día</th><th>Kg/Sem</th></tr>
      </thead>
      <tbody>
        ${filaComparativaA(`Estándar base (${cm.categoria_diametro}: ${cm.mesas_empaque_manual_std} mesa emp. + ${cm.mesas_sellado_manual_std} mesa sell.)`, base, false)}
        ${filaComparativaA('Elegido' + (mesasE&&mesasS? ` (${mesasE} mesa emp. + ${mesasS} mesa sell.)` : ''), elegido, true)}
      </tbody>
    </table>`;

  document.getElementById('manualAResultado').innerHTML = tabla;
}

function bloqueSimuladorManualA(codigo){
  const info = skus[codigo].lineas.A;
  const cm = info.config_manual;
  const opt = (val, std) => `<option value="${val}" ${val===std?'selected':''}>${val}</option>`;
  return `
      <div class="subhead">Simulador — mesas de empaque y sellado manual (Línea A)</div>
      <div class="hint">Línea A es 100% empaque manual. Estándar base sugerido según diámetro (${fmt(cm.categoria_diametro)}): ${fmt(cm.mesas_empaque_manual_std)} mesa(s) empaque + ${fmt(cm.mesas_sellado_manual_std)} mesa(s) sellado — sujeto a ajuste. Prueba otras combinaciones para ver el efecto en Cajas/Min.</div>
      <div class="filtros" style="margin-bottom:6px;">
        <label style="font-size:11.5px;color:var(--text-dim);">Mesas Empaque Manual
          <select id="manualAMesasE" onchange="recalcularManualAUI('${codigo}')">
            ${opt(1, cm.mesas_empaque_manual_std)}
            ${opt(2, cm.mesas_empaque_manual_std)}
          </select>
        </label>
        <label style="font-size:11.5px;color:var(--text-dim);">Mesas Sellado Manual
          <select id="manualAMesasS" onchange="recalcularManualAUI('${codigo}')">
            ${opt(1, cm.mesas_sellado_manual_std)}
            ${opt(2, cm.mesas_sellado_manual_std)}
            ${opt(3, cm.mesas_sellado_manual_std)}
          </select>
        </label>
        <button class="chip active" onclick="recalcularManualAUI('${codigo}')">Recalcular</button>
      </div>
      <div id="manualAResultado"></div>`;
}

function mostrarTab(nombre){
  document.getElementById('tabEvolucion').classList.toggle('active', nombre==='evolucion');
  document.getElementById('tabExplorador').classList.toggle('active', nombre==='explorador');
  document.getElementById('tabBtnEvolucion').classList.toggle('active', nombre==='evolucion');
  document.getElementById('tabBtnExplorador').classList.toggle('active', nombre==='explorador');
  document.getElementById('tabTabla').classList.toggle('active', nombre==='tabla');
  document.getElementById('tabBtnTabla').classList.toggle('active', nombre==='tabla');
  document.getElementById('tabSimulador').classList.toggle('active', nombre==='simulador');
  document.getElementById('tabBtnSimulador').classList.toggle('active', nombre==='simulador');
  document.getElementById('tabParos').classList.toggle('active', nombre==='paros');
  document.getElementById('tabBtnParos').classList.toggle('active', nombre==='paros');
  const tabAdmin = document.getElementById('tabAdmin');
  const tabBtnAdmin = document.getElementById('tabBtnAdmin');
  if(tabAdmin) tabAdmin.classList.toggle('active', nombre==='admin');
  if(tabBtnAdmin) tabBtnAdmin.classList.toggle('active', nombre==='admin');
}

function toggleTheme(){
  const html = document.documentElement;
  const actual = html.getAttribute('data-theme') || 'dark';
  const siguiente = actual === 'dark' ? 'light' : 'dark';
  html.setAttribute('data-theme', siguiente);
  document.getElementById('themeToggleBtn').textContent = siguiente === 'dark' ? '🌙 Oscuro' : '☀️ Claro';
}

const oeeState = {};
const TPP_REFERENCIA = { 720:'TURNO', 1440:'DÍA', 8640:'SEM', 34560:'MES' };

function oeeKey(codigo, letra){ return codigo + '::' + letra; }

function getOeeState(codigo, letra){
  const key = oeeKey(codigo, letra);
  if(!oeeState[key]){
    const info = skus[codigo].lineas[letra];
    oeeState[key] = {
      golpesReal: info.amasado.golpes_real,
      calidadPct: info.velocidad.calidad_pct_std * 100,
      tpp: 720,
      tiempoParada: 0,
      periodoProduccion: 'tpp',
    };
  }
  return oeeState[key];
}

function calcularCascadaOEE(codigo, letra, st){
  const info = skus[codigo].lineas[letra];
  const am = info.amasado, ve = info.velocidad, id = info.identificacion;
  const rendimiento = st.golpesReal / am.golpes_nominal;
  const calidad = st.calidadPct / 100;
  const disponibilidad = (st.tpp - st.tiempoParada) / st.tpp;
  const oee = disponibilidad * rendimiento * calidad;
  const tortillasMinReal = ve.tdh_teorico_min * rendimiento * calidad;
  const paqMinRealProceso = tortillasMinReal / id.und_paq;
  const kgMinReal = tortillasMinReal * id.peso_tortilla_kg;
  const cajasMinRealProceso = id.paq_caja ? paqMinRealProceso / id.paq_caja : null;

  const periodos = { tpp: st.tpp, dia: 1440, sem: 8640, mes: 34560 };
  const paquetes = {}, kg = {}, batch = {};
  // Paq/Batch teórico (100% conversión, sin mermas): tortillas que rinde un
  // batch (peso de masa ÷ peso de esfera) convertidas a paquetes.
  const tortillasPorBatch = (am.peso_masa_kg_batch && id.peso_esfera_kg) ? am.peso_masa_kg_batch / id.peso_esfera_kg : null;
  const paqPorBatch = (tortillasPorBatch && id.und_paq) ? tortillasPorBatch / id.und_paq : null;
  // Paq BUENOS por batch: se descuenta la Calidad (masa real que se rechaza),
  // no el Rendimiento (que solo hace más lento el proceso, no destruye masa
  // — ese efecto ya está reflejado en paqMinRealProceso, no debe duplicarse
  // aquí en el conteo de batches).
  const paqBuenosPorBatch = (paqPorBatch!==null) ? paqPorBatch * calidad : null;
  // Batch/min al ritmo real de proceso (mismo criterio: descuenta Calidad,
  // no Rendimiento — ya incorporado en paqMinRealProceso).
  const batchMinRealProceso = (paqBuenosPorBatch) ? paqMinRealProceso / paqBuenosPorBatch : null;
  Object.keys(periodos).forEach(p => {
    paquetes[p] = paqMinRealProceso * periodos[p] * disponibilidad;
    kg[p] = kgMinReal * periodos[p] * disponibilidad;
    batch[p] = (paqBuenosPorBatch) ? Math.ceil(paquetes[p] / paqBuenosPorBatch) : null;
  });

  return { rendimiento, calidad, disponibilidad, oee, tortillasMinReal, paqMinRealProceso, kgMinReal, cajasMinRealProceso, batchMinRealProceso, paquetes, kg, batch };
}

// Tablas TRANSPUESTAS (métrica en filas, escenario en columnas) para poder
// ver todo el contenido sin desplazamiento horizontal — con muchas métricas
// por escenario, la versión "ancha" (escenario en filas) se sale de pantalla.
function tablaCascadaOEE(base, editado, etiquetaBase, etiquetaEditado){
  const pct = v => (v===null||v===undefined) ? '—' : (v*100).toFixed(1)+'%';
  const fh = v => (v===null||v===undefined) ? '—' : porHora(v).toFixed(1);
  const filas = [
    ['Rendimiento', pct(base.rendimiento), pct(editado.rendimiento)],
    ['Calidad', pct(base.calidad), pct(editado.calidad)],
    ['Disponibilidad', pct(base.disponibilidad), pct(editado.disponibilidad)],
    ['OEE', pct(base.oee), pct(editado.oee)],
    ['Paq/Hora Real (Proceso)', fh(base.paqMinRealProceso), fh(editado.paqMinRealProceso)],
    ['Batch/Hora Real (Proceso)', base.batchMinRealProceso==null?'—':porHora(base.batchMinRealProceso).toFixed(2), editado.batchMinRealProceso==null?'—':porHora(editado.batchMinRealProceso).toFixed(2)],
    ['Cajas/Hora Real (Proceso)', base.cajasMinRealProceso==null?'—':fh(base.cajasMinRealProceso), editado.cajasMinRealProceso==null?'—':fh(editado.cajasMinRealProceso)],
  ];
  const filasHtml = filas.map(([label,vb,ve])=>`<tr><td>${label}</td><td>${vb}</td><td style="font-weight:700;">${ve}</td></tr>`).join('');
  return `<table style="margin-top:10px;">
    <thead><tr><th>Métrica</th><th>${etiquetaBase}</th><th>${etiquetaEditado}</th></tr></thead>
    <tbody>${filasHtml}</tbody>
  </table>`;
}

const PERIODO_ETIQUETAS_OEE = { tpp:'TPP', dia:'Día', sem:'Sem', mes:'Mes' };

function tablaProduccionOEE(base, editado, etiquetaBase, etiquetaEditado, periodo, periodoLabel){
  const grupos = [
    ['Batch (und)/'+periodoLabel, 'batch', 0],
    ['Paquetes/'+periodoLabel, 'paquetes', 0],
    ['Kg/'+periodoLabel, 'kg', 1],
  ];
  const val = (r, obj, dec) => {
    const v = r[obj] ? r[obj][periodo] : null;
    if(v===null || v===undefined) return '—';
    return dec ? v.toFixed(dec) : Math.round(v);
  };
  const filasHtml = grupos.map(([label,obj,dec])=>
    `<tr><td>${label}</td><td>${val(base,obj,dec)}</td><td style="font-weight:700;">${val(editado,obj,dec)}</td></tr>`
  ).join('');
  return `<table>
    <thead><tr><th>Métrica</th><th>${etiquetaBase}</th><th>${etiquetaEditado}</th></tr></thead>
    <tbody>${filasHtml}</tbody>
  </table>`;
}

function renderOeeResultado(codigo, letra){
  const st = getOeeState(codigo, letra);
  const info = skus[codigo].lineas[letra];
  const stdState = { golpesReal: info.amasado.golpes_real, calidadPct: info.velocidad.calidad_pct_std*100, tpp: 720, tiempoParada: 0 };
  const base = calcularCascadaOEE(codigo, letra, stdState);
  const editado = calcularCascadaOEE(codigo, letra, st);
  const etiquetaTPP = TPP_REFERENCIA[st.tpp] || 'TPP';
  const etiquetaBase = 'Actual (Maestro, TPP = TURNO 720 min)';
  const etiquetaEditado = `Editado (TPP = ${etiquetaTPP}, ${st.tpp} min)`;
  const periodo = st.periodoProduccion || 'tpp';
  const periodoLabel = periodo === 'tpp' ? etiquetaTPP : PERIODO_ETIQUETAS_OEE[periodo];
  const tabla = `
    ${tablaCascadaOEE(base, editado, etiquetaBase, etiquetaEditado)}
    <div class="subhead" style="margin-top:14px; display:flex; align-items:center; justify-content:space-between; gap:10px; flex-wrap:wrap;">
      <span>Proyección de producción (usa la Disponibilidad de arriba)</span>
      <label style="display:flex; align-items:center; gap:6px; font-size:11.5px; color:var(--text-dim); font-weight:400;">Período
        <select id="oeePeriodo_${letra}" onchange="cambiarPeriodoProduccionOEE('${codigo}','${letra}')">
          <option value="tpp" ${periodo==='tpp'?'selected':''}>TPP (${st.tpp} min, arriba)</option>
          <option value="dia" ${periodo==='dia'?'selected':''}>Día (1,440 min)</option>
          <option value="sem" ${periodo==='sem'?'selected':''}>Semana (8,640 min)</option>
          <option value="mes" ${periodo==='mes'?'selected':''}>Mes (34,560 min)</option>
        </select>
      </label>
    </div>
    <div class="hint">Batch (und) descuenta la Calidad (la masa rechazada de verdad se pierde) pero no el Rendimiento (que solo hace más lento el proceso, no destruye masa) — ese efecto ya está reflejado en los Paquetes/Kg de la columna.</div>
    ${tablaProduccionOEE(base, editado, etiquetaBase, etiquetaEditado, periodo, periodoLabel)}`;
  const el = document.getElementById('oeeResultado_'+letra);
  if(el) el.innerHTML = tabla;
}

function cambiarPeriodoProduccionOEE(codigo, letra){
  const st = getOeeState(codigo, letra);
  const v = document.getElementById('oeePeriodo_'+letra).value;
  st.periodoProduccion = v;
  renderOeeResultado(codigo, letra);
}

function aplicarGolpesOEE(codigo, letra){
  const st = getOeeState(codigo, letra);
  const v = parseFloat(document.getElementById('oeeGolpesReal_'+letra).value);
  if(!isNaN(v) && v > 0) st.golpesReal = v;
  renderOeeResultado(codigo, letra);
}

function aplicarCalidadOEE(codigo, letra){
  const st = getOeeState(codigo, letra);
  const v = parseFloat(document.getElementById('oeeCalidad_'+letra).value);
  if(!isNaN(v) && v >= 0) st.calidadPct = v;
  renderOeeResultado(codigo, letra);
}

function aplicarDisponibilidadOEE(codigo, letra){
  const st = getOeeState(codigo, letra);
  const tpp = parseInt(document.getElementById('oeeTPP_'+letra).value, 10);
  const parada = parseFloat(document.getElementById('oeeTiempoParada_'+letra).value);
  if(!isNaN(tpp) && tpp > 0) st.tpp = tpp;
  if(!isNaN(parada) && parada >= 0) st.tiempoParada = parada;
  renderOeeResultado(codigo, letra);
}

function bloqueSimuladorOEE(codigo, letra){
  const st = getOeeState(codigo, letra);
  const info = skus[codigo].lineas[letra];
  const am = info.amasado;
  return `
      <div class="subhead">Simulador OEE — Golpes, Calidad y Disponibilidad (ejercicio paralelo, no modifica la plantilla)</div>
      <div class="hint">Cada control es independiente y su valor se mantiene aunque uses los otros dos. Golpes Nominal fijo: ${fmt(am.golpes_nominal)}/min.</div>
      <div class="kv-grid" style="margin-bottom:10px;">
        <div class="kv"><div class="l">TPP · TURNO</div><div class="v">720 min</div></div>
        <div class="kv"><div class="l">TPP · DÍA</div><div class="v">1,440 min</div></div>
        <div class="kv"><div class="l">TPP · SEM</div><div class="v">8,640 min (144 h)</div></div>
        <div class="kv"><div class="l">TPP · MES</div><div class="v">34,560 min</div></div>
      </div>
      <div class="filtros" style="margin-bottom:6px; flex-wrap:wrap; gap:14px;">
        <span style="display:flex; gap:6px; align-items:center;">
          <label style="font-size:11.5px;color:var(--text-dim);">Golpes Reales
            <input type="number" id="oeeGolpesReal_${letra}" value="${st.golpesReal}" step="0.1" style="width:70px;">
          </label>
          <button class="chip active" onclick="aplicarGolpesOEE('${codigo}','${letra}')">Recalcular Rendimiento</button>
        </span>
        <span style="display:flex; gap:6px; align-items:center;">
          <label style="font-size:11.5px;color:var(--text-dim);">Calidad %
            <input type="number" id="oeeCalidad_${letra}" value="${st.calidadPct}" step="0.1" style="width:70px;">
          </label>
          <button class="chip active" onclick="aplicarCalidadOEE('${codigo}','${letra}')">Recalcular Calidad</button>
        </span>
        <span style="display:flex; gap:6px; align-items:center;">
          <label style="font-size:11.5px;color:var(--text-dim);">TPP — Tiempo Programado Producción (min)
            <input type="number" id="oeeTPP_${letra}" value="${st.tpp}" step="1" min="1" style="width:90px;">
          </label>
          <label style="font-size:11.5px;color:var(--text-dim);">Tiempo de Parada (min)
            <input type="number" id="oeeTiempoParada_${letra}" value="${st.tiempoParada}" step="1" style="width:70px;">
          </label>
          <button class="chip active" onclick="aplicarDisponibilidadOEE('${codigo}','${letra}')">Recalcular Disponibilidad</button>
        </span>
      </div>
      <div id="oeeResultado_${letra}"></div>`;
}

function bloqueLinea(letra, nombreEquipo, info, codigo){
  if(!info.produce){
    return `<div class="linea-block no-produce">
      <div class="linea-block-head"><span class="tag">LÍNEA ${letra}</span><span class="pill no">NO SE PRODUCE</span></div>
      <div class="linea-block-body">Esta referencia no está configurada para producirse en Línea ${letra}.</div>
    </div>`;
  }
  const id = info.identificacion, am = info.amasado, ve = info.velocidad, de = info.derivados;
  const badge = badgeEmpaque(info);

  // Batches (amasado) necesarios por paquete/caja/estiba: se parte de cuántas
  // tortillas rinde un batch (peso de masa del batch entre peso de esfera),
  // se convierte a paquetes, y se invierte para saber cuántos batches hacen
  // falta por unidad de empaque.
  const tortillasPorBatch = (am.peso_masa_kg_batch && id.peso_esfera_kg) ? am.peso_masa_kg_batch / id.peso_esfera_kg : null;
  const paqPorBatch = (tortillasPorBatch && id.und_paq) ? tortillasPorBatch / id.und_paq : null;
  const batchPorPaq = paqPorBatch ? 1 / paqPorBatch : null;
  const batchPorCaja = (batchPorPaq && id.paq_caja) ? batchPorPaq * id.paq_caja : null;
  const batchPorEstiba = (batchPorCaja && id.cajas_estiba) ? batchPorCaja * id.cajas_estiba : null;

  return `<div class="linea-block">
    <div class="linea-block-head">
      <span class="tag">LÍNEA ${letra} — ${id.equipo_molde||''}</span>
      ${badge}
    </div>
    <div class="linea-block-body">
      <div class="kpi-grid">
        <div class="kpi"><div class="l">Kg/h Real</div><div class="v">${fmt(de.kg_h_real,1)}</div></div>
        <div class="kpi"><div class="l">Kg/h Teórico</div><div class="v">${fmt(de.kg_h_teorico,1)}</div></div>
        <div class="kpi"><div class="l">Cajas/h Real</div><div class="v">${fmt(de.cajas_h_real,1)}</div></div>
        <div class="kpi"><div class="l">Paq/h Real</div><div class="v">${fmt(de.paq_h_real,1)}</div></div>
      </div>

      <div class="subhead">Identificación y empaque</div>
      <div class="kv-grid">
        <div class="kv"><div class="l">Diámetro</div><div class="v">${fmt(id.diametro_cm)} cm</div></div>
        <div class="kv"><div class="l">Tipo empaque</div><div class="v">${fmt(id.tipo_empaque)}</div></div>
        <div class="kv"><div class="l">Peso tortilla</div><div class="v">${fmt(id.peso_tortilla_kg)} kg</div></div>
        <div class="kv"><div class="l">Peso esfera</div><div class="v">${fmt(id.peso_esfera_kg)} kg</div></div>
        <div class="kv"><div class="l">Und/Paquete</div><div class="v">${fmt(id.und_paq)}</div></div>
        <div class="kv"><div class="l">Peso paquete</div><div class="v">${fmt(id.peso_paq_kg)} kg</div></div>
        <div class="kv"><div class="l">Paq/Caja</div><div class="v">${fmt(id.paq_caja)}</div></div>
        <div class="kv"><div class="l">Cajas/Estiba</div><div class="v">${fmt(id.cajas_estiba)}</div></div>
        <div class="kv"><div class="l">Vida útil</div><div class="v">${id.vida_util_d===0?'⚠ 0 (sin dato)':fmt(id.vida_util_d)+' d'}</div></div>
        <div class="kv"><div class="l">Tipo producto</div><div class="v">${fmt(id.tipo_producto)}</div></div>
        <div class="kv"><div class="l">Sabor/Tipo</div><div class="v">${fmt(id.sabor_tipo)}</div></div>
        <div class="kv"><div class="l">Destino</div><div class="v">${fmt(id.destino)}</div></div>
      </div>

      <div class="subhead">Amasado (formulación por batch)</div>
      <div class="kv-grid">
        <div class="kv"><div class="l">Harina Natural</div><div class="v">${fmt(am.harina_natural_kg_batch)} kg</div></div>
        <div class="kv"><div class="l">Harina Integral</div><div class="v">${fmt(am.harina_integral_kg_batch)} kg</div></div>
        <div class="kv"><div class="l">Formulación</div><div class="v">${fmt(am.formulacion_kg_batch)} kg</div></div>
        <div class="kv"><div class="l">Cód. Formulación</div><div class="v">${fmt(am.cod_formulacion)}</div></div>
        <div class="kv"><div class="l">Grasa Vegetal</div><div class="v">${fmt(am.grasa_vegetal_kg_batch)} kg</div></div>
        <div class="kv"><div class="l">Agua</div><div class="v">${fmt(am.agua_kg_batch)} kg</div></div>
        <div class="kv"><div class="l">Tortillas/Golpe</div><div class="v">${fmt(am.tortillas_golpe)}</div></div>
        <div class="kv"><div class="l">Golpes Nominal</div><div class="v">${fmt(am.golpes_nominal)}/min</div></div>
        <div class="kv"><div class="l">Golpes Real</div><div class="v">${fmt(am.golpes_real)}/min</div></div>
        <div class="kv"><div class="l">Peso Masa</div><div class="v">${fmt(am.peso_masa_kg_batch)} kg</div></div>
      </div>

      <div class="subhead">Cascada de velocidad / OEE</div>
      <div class="hint">Kg, Paq y Cajas mostrados en unidades por hora (los datos fuente están por minuto — aquí ya multiplicados x60).</div>
      <table>
        <tbody>
          <tr><td>TDH Teórico [min]</td><td>${fmt(ve.tdh_teorico_min)}</td><td>Disponibilidad Std</td><td>${fmt(ve.disp_pct_std)}</td></tr>
          <tr><td>Rendimiento Std</td><td>${fmt(ve.rend_pct_std)}</td><td>Calidad Std</td><td>${fmt(ve.calidad_pct_std)}</td></tr>
          <tr><td>OEE Calculado</td><td>${fmt(ve.oee_calc)}</td><td>Máx Paq/Hora Empacadora</td><td>${fmt(porHora(ve.max_paq_min_empacadora),1)}</td></tr>
          <tr><td>Máx Paq/Hora Tramo Manual</td><td>${ve.max_paq_min_tramo_manual===null||ve.max_paq_min_tramo_manual===undefined?'sin definir':fmt(porHora(ve.max_paq_min_tramo_manual),1)}</td><td>Tortillas/min Real</td><td>${fmt(ve.tortillas_min_real)}</td></tr>
          <tr><td>Kg/Hora Teórico</td><td>${fmt(porHora(ve.kg_min_teorico),1)}</td><td>Kg/Hora Real</td><td>${fmt(porHora(ve.kg_min_real),1)}</td></tr>
          <tr><td>Paq/Hora Real (Proceso)</td><td>${fmt(porHora(ve.paq_min_real_proceso),1)}</td><td>Paq/Hora Real Final</td><td>${fmt(porHora(ve.paq_min_real_final),1)}</td></tr>
          <tr><td>Cajas/Hora Real Final</td><td colspan="3">${fmt(porHora(ve.cajas_min_real_final),1)}</td></tr>
        </tbody>
      </table>

      <div class="subhead">Rendimiento por Batch</div>
      <div class="hint">Batches (amasado) necesarios para completar un paquete, una caja o una estiba de esta referencia en esta línea. Basado en Peso Masa/Batch ÷ Peso Esfera.</div>
      <div class="kv-grid">
        <div class="kv"><div class="l">Tortillas/Batch</div><div class="v">${fmt(tortillasPorBatch,1)}</div></div>
        <div class="kv"><div class="l">Paq/Batch</div><div class="v">${fmt(paqPorBatch,2)}</div></div>
        <div class="kv"><div class="l">Batch/Paq</div><div class="v">${fmt(batchPorPaq,5)}</div></div>
        <div class="kv"><div class="l">Batch/Caja</div><div class="v">${fmt(batchPorCaja,4)}</div></div>
        <div class="kv"><div class="l">Batch/Estiba</div><div class="v">${fmt(batchPorEstiba,3)}</div></div>
      </div>
      ${bloqueSimuladorOEE(codigo, letra)}
      ${letra==='A' ? bloqueSimuladorManualA(codigo) : ''}
      ${bloqueEmpaqueMixto(info.empaque_mixto, codigo)}
    </div>
  </div>`;
}

function mostrarReferenciaEnLinea(letra, codigo){
  const e = skus[codigo];
  if(!e) return;
  const cont = document.getElementById('contenedorLinea'+letra);
  cont.innerHTML = `<div class="ref-card">
    <div class="ref-header">
      <div>
        <div class="ref-title">${e.codigo} <span style="font-size:11px; font-weight:400; color:var(--text-dim);">— mostrando en Línea ${letra}</span></div>
        <div class="ref-desc">${e.descripcion}</div>
      </div>
    </div>
    <div class="ref-body">
      ${bloqueLinea(letra, NOMBRE_EQUIPO[letra], e.lineas[letra], e.codigo)}
    </div>
  </div>`;
  if(document.getElementById('oeeResultado_'+letra)) renderOeeResultado(codigo, letra);
  if(letra==='A' && document.getElementById('manualAMesasE')) recalcularManualAUI(codigo);
  if(letra==='C' && document.getElementById('mixtoDivisionSel')) recalcularMixtoUI(codigo);
  window.scrollTo({top: cont.offsetTop - 80, behavior:'smooth'});
}

function mostrarReferenciaEnTodas(codigo){
  ['A','B','C'].forEach(letra=>{
    if(skus[codigo].lineas[letra].produce) mostrarReferenciaEnLinea(letra, codigo);
  });
}

// ---- Tabla global ----
let filtroActivo = 'todas';
let sortCol = 'codigo';
let sortDir = 1;

function pillToggle(codigo, letra, prod, exc){
  const cls = !prod ? 'no' : (exc ? 'exc' : 'si');
  const txt = !prod ? 'NO' : 'SÍ';
  return `<button class="pill pill-toggle ${cls}" title="Clic para activar/desactivar Línea ${letra} en esta referencia (afecta el buscador)" onclick="event.stopPropagation(); toggleProduccionLinea('${codigo}','${letra}')">${txt}</button>`;
}

function toggleProduccionLinea(codigo, letra){
  const info = skus[codigo].lineas[letra];
  info.produce = !info.produce;
  renderTabla();
  const buscadorInput = document.getElementById('buscador'+letra);
  if(buscadorInput) renderResultadosLinea(letra, buscadorInput.value);
  const cont = document.getElementById('contenedorLinea'+letra);
  if(cont && cont.querySelector('.ref-title') && cont.querySelector('.ref-title').textContent.trim().startsWith(codigo)){
    mostrarReferenciaEnLinea(letra, codigo);
  }
}

function filaData(codigo){
  const e = skus[codigo];
  return {
    codigo,
    descripcion: e.descripcion,
    diametro: e.lineas.A.produce ? e.lineas.A.identificacion.diametro_cm : (e.lineas.B.produce? e.lineas.B.identificacion.diametro_cm : (e.lineas.C.produce ? e.lineas.C.identificacion.diametro_cm : null)),
    A: e.lineas.A.produce,
    kgA: e.lineas.A.produce ? e.lineas.A.derivados.kg_h_real : null,
    B: e.lineas.B.produce,
    kgB: e.lineas.B.produce ? e.lineas.B.derivados.kg_h_real : null,
    C: e.lineas.C.produce,
    kgC: e.lineas.C.produce ? e.lineas.C.derivados.kg_h_real : null,
  };
}

function renderTabla(){
  const q = (document.getElementById('buscadorTabla').value||'').trim().toUpperCase();
  let rows = codes.map(filaData);
  if(filtroActivo==='solo-a') rows = rows.filter(r=> r.A && !r.B && !r.C);
  if(filtroActivo==='a-b-c') rows = rows.filter(r=> r.A && r.B && r.C);
  if(q) rows = rows.filter(r=> r.codigo.toUpperCase().includes(q) || (r.descripcion||'').toUpperCase().includes(q));
  rows.sort((a,b)=>{
    let va = a[sortCol], vb = b[sortCol];
    if(typeof va === 'boolean'){ va = va?1:0; vb = vb?1:0; }
    if(va===null) va = -Infinity; if(vb===null) vb = -Infinity;
    if(typeof va === 'string') return va.localeCompare(vb)*sortDir;
    return (va-vb)*sortDir;
  });
  const tbody = document.getElementById('tbodyGlobal');
  tbody.innerHTML = rows.map(r=>`<tr data-codigo="${r.codigo}" style="cursor:pointer;">
    <td>${r.codigo}</td>
    <td class="desc-cell">${r.descripcion}</td>
    <td>${fmt(r.diametro)}</td>
    <td>${pillToggle(r.codigo,'A',r.A,false)}</td>
    <td>${fmt(r.kgA,1)}</td>
    <td>${pillToggle(r.codigo,'B',r.B,skus[r.codigo].lineas.B.excepcion_config)}</td>
    <td>${fmt(r.kgB,1)}</td>
    <td>${pillToggle(r.codigo,'C',r.C,skus[r.codigo].lineas.C.excepcion_config)}</td>
    <td>${fmt(r.kgC,1)}</td>
  </tr>`).join('');
  tbody.querySelectorAll('tr').forEach(tr=>{
    tr.addEventListener('click', ()=> { mostrarTab('explorador'); mostrarReferenciaEnTodas(tr.dataset.codigo); });
  });
}

// ============================================================
// SIMULADOR DE CAPACIDAD — herramienta de planeación consolidada:
// elige línea + referencia + demanda + escenario de empaque, y compara
// el resultado calculado contra los valores nominales (estándar) de la
// plantilla. No modifica ni depende de los otros simuladores por
// referencia (OEE / Mixto / Manual A); es una vista independiente.
// ============================================================

function referenciasPorLinea(letra){
  return codes.filter(c => skus[c].lineas[letra].produce);
}

// Velocidad (Paq/min) asumida para una "empacadora automática" en el
// escenario futuro de esta línea. En B y C ya existe una empacadora
// automática real (ve.max_paq_min_empacadora); ahí se reutiliza tal
// cual. Línea A hoy es 100% manual y no tiene ese dato propio, así que
// el supuesto se toma prestado de la misma referencia en Línea C (o B
// si C no aplica) — se deja siempre explícito en pantalla de dónde
// sale el número, para que se pueda auditar o cuestionar.
function velocidadAutomaticaSupuesta(codigo, letra){
  const e = skus[codigo];
  if(letra !== 'A'){
    const v = e.lineas[letra].velocidad.max_paq_min_empacadora;
    return { valor: v ?? null, fuente: `dato real de Línea ${letra}` };
  }
  if(e.lineas.C && e.lineas.C.produce && e.lineas.C.velocidad.max_paq_min_empacadora){
    return { valor: e.lineas.C.velocidad.max_paq_min_empacadora, fuente: 'supuesto — tomado de Línea C (Línea A no tiene empacadora automática real hoy)' };
  }
  if(e.lineas.B && e.lineas.B.produce && e.lineas.B.velocidad.max_paq_min_empacadora){
    return { valor: e.lineas.B.velocidad.max_paq_min_empacadora, fuente: 'supuesto — tomado de Línea B (Línea A no tiene empacadora automática real hoy)' };
  }
  return { valor: null, fuente: 'sin dato disponible para estimar (esta referencia no tiene empacadora automática real en B ni C)' };
}

function renderSimTipoEmpaque(){
  const letra = document.getElementById('simLinea').value;
  const codigo = document.getElementById('simReferencia').value;
  const box = document.getElementById('simTipoEmpaqueBox');
  if(!codigo || !skus[codigo]){ box.innerHTML = ''; return; }
  const info = skus[codigo].lineas[letra];

  if(letra === 'A'){
    const cm = info.config_manual || {};
    const opt = (v, std) => `<option value="${v}" ${std===v?'selected':''}>${v}</option>`;
    box.innerHTML = `
      <label style="display:flex;flex-direction:column;gap:4px;font-size:11.5px;color:var(--text-dim);grid-column:span 3;">Tipo de empaque
        <select id="simTipoEmpaqueA" onchange="onSimTipoEmpaqueAChange()">
          <option value="manual">Manual (actual)</option>
          <option value="auto">Empacadora automática (futuro — simulado)</option>
        </select>
      </label>
      <div id="simMesasBox" style="grid-column:span 3;display:flex;gap:10px;flex-wrap:wrap;">
        <label style="font-size:11.5px;color:var(--text-dim);">Mesas Empaque
          <select id="simMesasE">${opt(1,cm.mesas_empaque_manual_std)}${opt(2,cm.mesas_empaque_manual_std)}</select>
        </label>
        <label style="font-size:11.5px;color:var(--text-dim);">Mesas Sellado
          <select id="simMesasS">${opt(1,cm.mesas_sellado_manual_std)}${opt(2,cm.mesas_sellado_manual_std)}${opt(3,cm.mesas_sellado_manual_std)}</select>
        </label>
      </div>
      <div id="simAutoHint" class="hint" style="display:none;grid-column:span 3;margin-top:0;"></div>`;
    return;
  }

  box.innerHTML = `
    <label style="display:flex;flex-direction:column;gap:4px;font-size:11.5px;color:var(--text-dim);grid-column:span 3;">Tipo de empaque
      <select id="simSegundaAuto">
        <option value="no">Configuración actual</option>
        <option value="si">+ Segunda empacadora automática (futuro — misma velocidad que la actual)</option>
      </select>
    </label>`;
}

function onSimTipoEmpaqueAChange(){
  const tipo = document.getElementById('simTipoEmpaqueA').value;
  document.getElementById('simMesasBox').style.display = tipo==='manual' ? 'flex' : 'none';
  const hint = document.getElementById('simAutoHint');
  if(tipo === 'auto'){
    const codigo = document.getElementById('simReferencia').value;
    const { valor, fuente } = velocidadAutomaticaSupuesta(codigo, 'A');
    hint.style.display = 'block';
    hint.textContent = `Supuesto: ${valor===null?'sin dato':fmt(valor)+' paq/min'} — ${fuente}.`;
  } else {
    hint.style.display = 'none';
  }
}

function onSimuladorReferenciaChange(){
  const letra = document.getElementById('simLinea').value;
  const codigo = document.getElementById('simReferencia').value;
  renderSimTipoEmpaque();
  if(codigo && skus[codigo]){
    document.getElementById('simGolpesReal').value = skus[codigo].lineas[letra].amasado.golpes_real;
  }
  document.getElementById('simuladorResultado').innerHTML = '';
}

// Buscador de referencia del Simulador — mismo patrón que los buscadores de
// la pestaña Explorador (renderResultadosLinea): se escribe código o
// descripción, aparece una lista filtrada, y al hacer clic en un resultado
// queda seleccionada esa referencia para el resto del formulario.
function renderSimReferenciaResultados(query){
  const letra = document.getElementById('simLinea').value;
  const box = document.getElementById('simReferenciaResultados');
  const q = (query||'').trim().toUpperCase();
  let matches = referenciasPorLinea(letra);
  if(q){
    matches = matches.filter(c=>{
      const e = skus[c];
      return c.toUpperCase().includes(q) || (e.descripcion||'').toUpperCase().includes(q);
    });
  }
  matches = matches.slice(0,60);
  if(matches.length===0){ box.innerHTML = '<div class="empty-state">Sin resultados.</div>'; return; }
  box.innerHTML = matches.map(c=>{
    const e = skus[c];
    return `<div class="resultado-item" data-codigo="${c}">
      <div class="resultado-info"><b>${c}</b> — <span class="resultado-desc">${e.descripcion}</span></div>
    </div>`;
  }).join('');
  box.querySelectorAll('.resultado-item').forEach(el=>{
    el.addEventListener('click', ()=> seleccionarSimReferencia(el.dataset.codigo));
  });
}

function seleccionarSimReferencia(codigo){
  document.getElementById('simReferencia').value = codigo;
  const buscador = document.getElementById('simReferenciaBuscador');
  const hint = document.getElementById('simReferenciaSeleccionadaHint');
  const e = skus[codigo];
  if(buscador) buscador.value = '';
  document.getElementById('simReferenciaResultados').innerHTML = '';
  if(hint) hint.innerHTML = e ? `Referencia seleccionada: <b>${codigo}</b> — ${e.descripcion}` : '';
  onSimuladorReferenciaChange();
}

function onSimuladorLineaChange(){
  const letra = document.getElementById('simLinea').value;
  const buscador = document.getElementById('simReferenciaBuscador');
  if(buscador) buscador.value = '';
  document.getElementById('simReferenciaResultados').innerHTML = '';
  const refs = referenciasPorLinea(letra);
  if(refs.length){
    seleccionarSimReferencia(refs[0]);
  } else {
    document.getElementById('simReferencia').value = '';
    const hint = document.getElementById('simReferenciaSeleccionadaHint');
    if(hint) hint.textContent = 'No hay referencias configuradas para esta línea.';
    onSimuladorReferenciaChange();
  }
}

function initSimulador(){
  onSimuladorLineaChange();
}

// Techo de empaque (Paq/min) impuesto por el escenario elegido. null =
// sin techo definido (no limita, solo aplica la capacidad de proceso).
function calcularCeilingEmpaqueSimulador(letra, codigo){
  if(letra === 'A'){
    const tipo = document.getElementById('simTipoEmpaqueA').value;
    if(tipo === 'auto'){
      const { valor, fuente } = velocidadAutomaticaSupuesta(codigo, 'A');
      return { maxCeiling: valor, detalle: `Empacadora automática (futuro — ${fuente})` };
    }
    const mesasE = parseInt(document.getElementById('simMesasE').value, 10) || null;
    const mesasS = parseInt(document.getElementById('simMesasS').value, 10) || null;
    const maxCeiling = (mesasE && mesasS) ? Math.min(mesasE*40, mesasS*29) : null;
    return { maxCeiling, detalle: `Manual — ${mesasE||'?'} mesa(s) empaque + ${mesasS||'?'} mesa(s) sellado` };
  }
  const ve = skus[codigo].lineas[letra].velocidad;
  const segunda = document.getElementById('simSegundaAuto').value === 'si';
  const base = ve.max_paq_min_empacadora ?? null;
  const maxCeiling = (segunda && base!==null) ? base*2 : base;
  return { maxCeiling, detalle: segunda ? 'Configuración actual + segunda empacadora automática (futuro, misma velocidad)' : 'Configuración actual' };
}

function calcularEscenarioSimulador(codigo, letra, { golpesReal, tpp, tiempoParo, calidad, maxCeiling }){
  const info = skus[codigo].lineas[letra];
  const am = info.amasado, ve = info.velocidad, id = info.identificacion;

  const rendimiento = am.golpes_nominal ? golpesReal / am.golpes_nominal : null;
  const disponibilidad = tpp ? (tpp - tiempoParo) / tpp : null;
  const calidadClamp = (calidad===null || calidad===undefined) ? null : Math.max(0, Math.min(1, calidad));

  const oee = (disponibilidad!==null && rendimiento!==null && calidadClamp!==null) ? disponibilidad*rendimiento*calidadClamp : null;

  const tortillasMinReal = ve.tdh_teorico_min * (rendimiento??0) * (calidadClamp??0);
  const paqMinProceso = id.und_paq ? tortillasMinReal / id.und_paq : 0;
  const kgMinProceso = tortillasMinReal * id.peso_tortilla_kg;

  const paqMinFinal = (maxCeiling!==null && maxCeiling!==undefined) ? Math.min(paqMinProceso, maxCeiling) : paqMinProceso;
  const factor = paqMinProceso ? (paqMinFinal/paqMinProceso) : 0;
  const kgMinFinal = kgMinProceso * factor;
  const cajasMinFinal = id.paq_caja ? paqMinFinal/id.paq_caja : null;

  // Paq/Min = ritmo mientras la línea está corriendo (no descuenta paros,
  // igual que paqMinRealProceso en el simulador OEE por referencia).
  // Paq/Hora en adelante sí deben reflejar la producción esperada del
  // período, así que se descuenta el tiempo de paro vía Disponibilidad —
  // mismo criterio que ya usa calcularCascadaOEE (paquetes[periodo] =
  // ritmo × minutos_periodo × disponibilidad). Sin este factor, un
  // escenario con más tiempo de paro podía mostrar "más producción por
  // hora" que uno sin paros, lo cual no tiene sentido físico.
  const disp = disponibilidad ?? 1;
  const mk = (perMin) => (perMin===null || perMin===undefined) ? null : {
    min: perMin,
    hora: perMin*60*disp,
    dia: perMin*60*24*disp,
    sem: perMin*60*144*disp,
  };

  return {
    rendimiento, calidad: calidadClamp, disponibilidad, oee,
    paq: mk(paqMinFinal), cajas: mk(cajasMinFinal), kg: mk(kgMinFinal),
  };
}

// Tabla TRANSPUESTA (métrica en filas, escenario en columnas) — con 17
// métricas por escenario, la versión "ancha" obligaba a desplazarse
// horizontalmente para verlas todas.
function tablaComparativaSimulador(nominal, calculado){
  const pct = v => (v===null||v===undefined) ? '—' : (v*100).toFixed(1)+'%';
  const f = (v,d) => (v===null||v===undefined) ? '—' : v.toFixed(d);
  const grupos = [
    { titulo:'Indicadores', metricas:[
      ['Rendimiento', r=>pct(r.rendimiento)],
      ['Calidad', r=>pct(r.calidad)],
      ['Disponibilidad', r=>pct(r.disponibilidad)],
      ['OEE', r=>pct(r.oee)],
      ['Batch (und)', r=>(r.batch===null||r.batch===undefined?'—':r.batch)],
    ]},
    { titulo:'Paquetes', metricas:[
      ['Paq/Min', r=>f(r.paq?.min,2)], ['Paq/Hora', r=>f(r.paq?.hora,1)], ['Paq/Día', r=>f(r.paq?.dia,0)], ['Paq/Sem', r=>f(r.paq?.sem,0)],
    ]},
    { titulo:'Cajas', metricas:[
      ['Cajas/Min', r=>f(r.cajas?.min,2)], ['Cajas/Hora', r=>f(r.cajas?.hora,1)], ['Cajas/Día', r=>f(r.cajas?.dia,0)], ['Cajas/Sem', r=>f(r.cajas?.sem,0)],
    ]},
    { titulo:'Kg', metricas:[
      ['Kg/Min', r=>f(r.kg?.min,2)], ['Kg/Hora', r=>f(r.kg?.hora,1)], ['Kg/Día', r=>f(r.kg?.dia,1)], ['Kg/Sem', r=>f(r.kg?.sem,1)],
    ]},
  ];
  const filasHtml = grupos.map(g=>{
    const cab = `<tr><td colspan="3" style="background:var(--bg-panel-2);font-weight:700;border-top:1px solid var(--line);">${g.titulo}</td></tr>`;
    const filas = g.metricas.map(([label,get])=>
      `<tr><td>${label}</td><td>${get(nominal)}</td><td style="font-weight:700;">${get(calculado)}</td></tr>`
    ).join('');
    return cab + filas;
  }).join('');
  return `<table>
    <thead><tr><th>Métrica</th><th>Nominal (estándar plantilla)</th><th>Calculado (tus datos)</th></tr></thead>
    <tbody>${filasHtml}</tbody>
  </table>`;
}

// Tiempo requerido para completar una Producción (Paq) objetivo, dado el
// ritmo BUENO de línea corriendo (paq.min ya descuenta Calidad) y la
// Disponibilidad del escenario (Golpes Reales → Rendimiento vía paq.min;
// Tiempo de Paro → Disponibilidad; Calidad-Rechazo → paq.min también, porque
// tortillasMinReal ya se calcula con calidadClamp). Se asume que el % de
// tiempo perdido en paros se mantiene proporcional sin importar cuánto dure
// la producción (mismo criterio que ya usan Paq/Hora, Paq/Día, Paq/Sem).
function calcularTiempoRequerido(escenario, demandaPaq){
  const ritmoBuenoMin = escenario?.paq?.min;
  if(!demandaPaq || !ritmoBuenoMin || ritmoBuenoMin <= 0) return null;
  const corridoMin = demandaPaq / ritmoBuenoMin;
  const disp = escenario.disponibilidad;
  if(disp === null || disp === undefined || disp <= 0) return { corridoMin, totalMin: null };
  return { corridoMin, totalMin: corridoMin / disp };
}

function fmtMinutos(min){
  if(min===null || min===undefined || !isFinite(min)) return '—';
  const horas = min/60, dias = min/1440, turnos = min/720;
  return `${fmt(min,0)} min · ${fmt(horas,1)} h · ${fmt(turnos,1)} turnos · ${fmt(dias,2)} d`;
}

function tablaTiempoRequerido(tNom, tCal){
  const filas = [
    ['Tiempo línea corriendo (Golpes Reales + Calidad — Rechazo)', tNom?.corridoMin, tCal?.corridoMin],
    ['Tiempo total estimado (+ Tiempo de Paro + Calidad — Rechazo)', tNom?.totalMin, tCal?.totalMin],
  ];
  const filasHtml = filas.map(([label,a,b])=>
    `<tr><td>${label}</td><td>${fmtMinutos(a)}</td><td style="font-weight:700;">${fmtMinutos(b)}</td></tr>`
  ).join('');
  return `<table style="margin-top:10px;">
    <thead><tr><th>Métrica</th><th>Nominal (estándar plantilla)</th><th>Calculado (tus datos)</th></tr></thead>
    <tbody>${filasHtml}</tbody>
  </table>`;
}

function calcularSimulador(){
  const letra = document.getElementById('simLinea').value;
  const codigo = document.getElementById('simReferencia').value;
  const box = document.getElementById('simuladorResultado');
  if(!codigo || !skus[codigo]){ box.innerHTML = '<div class="panel"><div class="empty-state">Elige una referencia.</div></div>'; return; }
  const info = skus[codigo].lineas[letra];
  if(!info.produce){ box.innerHTML = '<div class="panel"><div class="empty-state">Esta referencia no se produce en esa línea.</div></div>'; return; }

  const demandaPaq = parseFloat(document.getElementById('simDemandaPaq').value) || 0;
  const golpesReal = parseFloat(document.getElementById('simGolpesReal').value);
  const tpp = parseInt(document.getElementById('simTPP').value, 10);
  const tiempoParo = parseFloat(document.getElementById('simTiempoParo').value) || 0;
  const rechazoPct = parseFloat(document.getElementById('simCalidadKg').value) || 0;

  const { maxCeiling, detalle } = calcularCeilingEmpaqueSimulador(letra, codigo);

  const am = info.amasado, ve = info.velocidad, id = info.identificacion;

  // Paq/Batch TEÓRICO (100% conversión, sin mermas): cuántas tortillas rinde
  // un batch (peso de masa ÷ peso de esfera) convertidas a paquetes. Es un
  // dato de receta, fijo, no depende de ningún escenario.
  const tortillasPorBatch = (am.peso_masa_kg_batch && id.peso_esfera_kg) ? am.peso_masa_kg_batch / id.peso_esfera_kg : null;
  const paqPorBatch = (tortillasPorBatch && id.und_paq) ? tortillasPorBatch / id.und_paq : null;

  // Calidad nominal = la calidad estándar de la plantilla (no se deriva de
  // kg de rechazo, ya viene como % en los datos fuente).
  const calidadNominal = ve.calidad_pct_std;

  // Calidad calculada = 100% − Rechazo (%), directo — equivalente a la
  // fórmula oficial de PNC/FPY (Producción buena ÷ (Producción buena + kg
  // rechazo)) pero expresada como porcentaje en vez de derivarla de un
  // balance de masa en kg, ya que PNC% = rechazo/(rechazo+buena) por
  // definición. Se recorta entre 0% y 100% por si se digita un valor fuera
  // de rango.
  const calidadCalculada = Math.max(0, Math.min(1, 1 - (rechazoPct/100)));

  // Batches necesarios = un balance de MASA, no de velocidad: de lo que
  // efectivamente sale de un batch, solo la fracción "Calidad" se vuelve
  // paquete vendible (el resto se rechaza y esa masa se pierde de verdad).
  // El Rendimiento NO entra aquí a propósito — Rendimiento es un factor de
  // tiempo/velocidad (micro-paros, ajustes), no destruye masa: la misma
  // cantidad de esferas que entran, eventualmente salen como tortilla, solo
  // toma más tiempo. Ese efecto ya está reflejado en Paq/Hora (que si usa
  // Rendimiento), no debe duplicarse aquí en el conteo de batches.
  const calcularBatch = (calidad) => {
    const paqBuenosPorBatch = (paqPorBatch!==null && calidad!==null && calidad!==undefined) ? paqPorBatch * calidad : null;
    return (paqBuenosPorBatch && demandaPaq) ? Math.ceil(demandaPaq / paqBuenosPorBatch) : null;
  };

  const nominal = calcularEscenarioSimulador(codigo, letra, {
    golpesReal: am.golpes_real, tpp: 720, tiempoParo: 0,
    calidad: calidadNominal, maxCeiling,
  });
  nominal.batch = calcularBatch(calidadNominal);

  const calculado = calcularEscenarioSimulador(codigo, letra, {
    golpesReal, tpp, tiempoParo, calidad: calidadCalculada, maxCeiling,
  });
  calculado.batch = calcularBatch(calidadCalculada);

  const tiempoNominal = calcularTiempoRequerido(nominal, demandaPaq);
  const tiempoCalculado = calcularTiempoRequerido(calculado, demandaPaq);
  const sinTiempoDisponible = calculado.disponibilidad !== null && calculado.disponibilidad !== undefined && calculado.disponibilidad <= 0;

  box.innerHTML = `
    <div class="panel">
      <h2>Resultado</h2>
      <div class="hint">Empaque asumido en ambos escenarios: ${detalle}${(maxCeiling===null||maxCeiling===undefined)?' (sin techo definido — no limita, solo aplica la capacidad de proceso)':''}.</div>
      <div class="hint">Paq/Min es el ritmo mientras la línea está corriendo (no descuenta el Tiempo de Paro). Paq/Hora, Paq/Día y Paq/Sem sí son producción esperada del período: ya descuentan el Tiempo de Paro a través de la Disponibilidad.</div>
      <div class="hint">Batch (und) descuenta la Calidad (la masa rechazada de verdad se pierde) pero no el Rendimiento (que solo hace más lento el proceso, no destruye masa) — por eso Nominal y Calculado pueden pedir distinto número de batches para la misma Producción.</div>
      <div class="kv-grid" style="margin-bottom:14px;">
        <div class="kv"><div class="l">Producción (Paq)</div><div class="v">${fmt(demandaPaq,0)}</div></div>
        <div class="kv"><div class="l">Paq/Batch (teórico)</div><div class="v">${fmt(paqPorBatch,2)}</div></div>
      </div>
      ${tablaComparativaSimulador(nominal, calculado)}
      <div class="subhead" style="margin-top:14px;">Tiempo requerido para completar la Producción (Paq)</div>
      <div class="hint">Recalcula automáticamente al cambiar Golpes Reales (Rendimiento → ritmo), Tiempo de Paro (Disponibilidad) o Calidad — Rechazo (paquetes buenos por minuto). Se asume que el % de tiempo perdido en paros se mantiene proporcional sin importar cuánto dure la producción.</div>
      ${demandaPaq ? tablaTiempoRequerido(tiempoNominal, tiempoCalculado) : '<div class="hint">Ingresa una Producción (Paq) mayor a 0 para ver el tiempo requerido.</div>'}
      ${sinTiempoDisponible ? '<div class="hint" style="color:var(--danger,#e5484d);">Con este Tiempo de Paro no queda tiempo disponible dentro del TPP elegido (Disponibilidad = 0%) — no es posible completar la producción en ese período.</div>' : ''}
    </div>`;
}

// ============================================================
// TIEMPOS DE CAMBIO Y PAROS — maestro de códigos de parada (incluye la
// matriz de tiempos de cambio de referencia). Fuente: PAROS/LISTADO
// MAESTRO CODIGOS PAROS USP.xlsx, cargado en Supabase (tabla codigos_paro).
// Vista de solo lectura para todos los usuarios autenticados; la edición
// (si se necesita) se hace por ahora directo en Supabase (RLS ya lo exige
// rol admin para escribir).
// ============================================================
let parosData = [];

function renderParosHeaderStats(){
  document.getElementById('hdrParosTotal').textContent = parosData.length;
  document.getElementById('hdrParosProgramados').textContent = parosData.filter(p=>p.tipo_parada==='PROGRAMADA').length;
  document.getElementById('hdrParosConTiempo').textContent = parosData.filter(p=>p.tiempo_estandar_min!==null && p.tiempo_estandar_min!==undefined).length;
}

function renderMatrizCambio(){
  const tbody = document.getElementById('tbodyMatrizCambio');
  const rows = parosData
    .filter(p => p.descripcion_motivo === 'CAMBIO REFERENCIA' && p.tiempo_estandar_min!==null && p.tiempo_estandar_min!==undefined)
    .sort((a,b)=> a.tiempo_estandar_min - b.tiempo_estandar_min);
  if(rows.length===0){ tbody.innerHTML = '<tr><td colspan="3" class="empty-state">Sin datos.</td></tr>'; return; }
  tbody.innerHTML = rows.map(p=>{
    const mayor = p.tiempo_estandar_min >= 300;
    return `<tr${mayor?' style="color:var(--warn-fg);font-weight:700;"':''}>
      <td>${p.codigo}</td>
      <td>${p.componente_motivo}${mayor?' ⚠':''}</td>
      <td>${fmt(p.tiempo_estandar_min)} min</td>
    </tr>`;
  }).join('');
}

function renderParosAdicionales(){
  const tbody = document.getElementById('tbodyParosAdicionales');
  const categorias = ['PUESTA A PUNTO','LIMPIEZA Y DESINFECCION','RUTINARIAS'];
  const rows = parosData
    .filter(p => categorias.includes(p.descripcion_motivo) && p.tiempo_estandar_min!==null && p.tiempo_estandar_min!==undefined)
    .sort((a,b)=> a.descripcion_motivo.localeCompare(b.descripcion_motivo) || a.tiempo_estandar_min - b.tiempo_estandar_min);
  if(rows.length===0){ tbody.innerHTML = '<tr><td colspan="4" class="empty-state">Sin datos.</td></tr>'; return; }
  tbody.innerHTML = rows.map(p=>`<tr>
    <td>${p.codigo}</td>
    <td>${p.descripcion_motivo}</td>
    <td>${p.componente_motivo}</td>
    <td>${fmt(p.tiempo_estandar_min)} min</td>
  </tr>`).join('');
}

let filtroParoActivo = 'todas';
let sortColParo = 'codigo';
let sortDirParo = 1;

function renderTablaParos(){
  const buscador = document.getElementById('buscadorParos');
  const q = (buscador ? buscador.value : '').trim().toUpperCase();
  let rows = parosData.slice();
  if(filtroParoActivo==='programada') rows = rows.filter(p=>p.tipo_parada==='PROGRAMADA');
  if(filtroParoActivo==='no-programada') rows = rows.filter(p=>p.tipo_parada==='NO PROGRAMADA');
  if(q) rows = rows.filter(p=>
    String(p.codigo).includes(q) ||
    (p.descripcion_motivo||'').toUpperCase().includes(q) ||
    (p.componente_motivo||'').toUpperCase().includes(q)
  );
  rows.sort((a,b)=>{
    let va = a[sortColParo], vb = b[sortColParo];
    if(va===null||va===undefined) va = -Infinity;
    if(vb===null||vb===undefined) vb = -Infinity;
    if(typeof va === 'string') return va.localeCompare(vb)*sortDirParo;
    return (va-vb)*sortDirParo;
  });
  const tbody = document.getElementById('tbodyParosCompleto');
  if(rows.length===0){ tbody.innerHTML = '<tr><td colspan="6" class="empty-state">Sin resultados.</td></tr>'; return; }
  tbody.innerHTML = rows.map(p=>`<tr>
    <td>${p.codigo}</td>
    <td>${p.descripcion_motivo}</td>
    <td>${p.componente_motivo}</td>
    <td>${fmt(p.origen_motivo)}</td>
    <td>${p.tipo_parada}</td>
    <td>${p.tiempo_estandar_min===null||p.tiempo_estandar_min===undefined?'—':fmt(p.tiempo_estandar_min)+' min'}</td>
  </tr>`).join('');
}

/**
 * Punto de entrada llamado una vez que llegan (o se actualizan) los datos
 * de codigos_paro desde Supabase.
 */
function applyParosData(data){
  parosData = data || [];
  renderParosHeaderStats();
  renderMatrizCambio();
  renderParosAdicionales();
  renderTablaParos();
}

function initEventListeners(){
  ['A','B','C'].forEach(letra=>{
    document.getElementById('buscador'+letra).addEventListener('input', e=> renderResultadosLinea(letra, e.target.value));
  });
  document.querySelectorAll('.chip[data-filtro]').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      document.querySelectorAll('.chip[data-filtro]').forEach(b=>b.classList.remove('active'));
      btn.classList.add('active');
      filtroActivo = btn.dataset.filtro;
      renderTabla();
    });
  });
  document.getElementById('buscadorTabla').addEventListener('input', renderTabla);
  document.querySelectorAll('#tablaGlobal th').forEach(th=>{
    th.addEventListener('click', ()=>{
      const col = th.dataset.col;
      if(sortCol===col) sortDir *= -1; else { sortCol = col; sortDir = 1; }
      document.querySelectorAll('#tablaGlobal th').forEach(x=>x.classList.remove('sorted'));
      th.classList.add('sorted');
      renderTabla();
    });
  });

  const simBuscador = document.getElementById('simReferenciaBuscador');
  if(simBuscador) simBuscador.addEventListener('input', e=> renderSimReferenciaResultados(e.target.value));

  document.querySelectorAll('.chip[data-filtro-paro]').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      document.querySelectorAll('.chip[data-filtro-paro]').forEach(b=>b.classList.remove('active'));
      btn.classList.add('active');
      filtroParoActivo = btn.dataset.filtroParo;
      renderTablaParos();
    });
  });
  document.getElementById('buscadorParos').addEventListener('input', renderTablaParos);
  document.querySelectorAll('#tablaParos th').forEach(th=>{
    th.addEventListener('click', ()=>{
      const col = th.dataset.colParo;
      if(sortColParo===col) sortDirParo *= -1; else { sortColParo = col; sortDirParo = 1; }
      document.querySelectorAll('#tablaParos th').forEach(x=>x.classList.remove('sorted'));
      th.classList.add('sorted');
      renderTablaParos();
    });
  });
}

/**
 * Punto de entrada llamado una vez que llegan (o se actualizan) los datos
 * desde Supabase. Sustituye la antigua asignación estática a DATA/skus/codes,
 * preservando el resto de la lógica de renderizado sin cambios.
 */
function applyData(data){
  skus = data.skus || {};
  codes = Object.keys(skus).sort((a,b)=> a.length-b.length || a.localeCompare(b));
  currentMeta = data.meta || { total_skus: codes.length };
  renderHeaderStats();
  ['A','B','C'].forEach(letra=>{
    const input = document.getElementById('buscador'+letra);
    renderResultadosLinea(letra, input ? input.value : '');
  });
  renderTabla();
  ['A','B','C'].forEach(letra=>{
    const cont = document.getElementById('contenedorLinea'+letra);
    const tituloEl = cont ? cont.querySelector('.ref-title') : null;
    const codigoAbierto = tituloEl ? tituloEl.textContent.trim().split(/\s+/)[0] : null;
    if(codigoAbierto && skus[codigoAbierto]) mostrarReferenciaEnLinea(letra, codigoAbierto);
  });
}

Object.assign(window, {
  mostrarTab, toggleTheme, recalcularMixtoUI, recalcularManualAUI,
  aplicarGolpesOEE, aplicarCalidadOEE, aplicarDisponibilidadOEE, toggleProduccionLinea,
  cambiarPeriodoProduccionOEE,
  onSimuladorLineaChange, onSimuladorReferenciaChange, onSimTipoEmpaqueAChange, calcularSimulador,
});

export { applyData, initEventListeners, initSimulador, applyParosData };
